import { RootState } from '@/app/store';

import { Permissions } from './featuresList';

export default function (state: RootState) {
  const _permission = state.user?.userConfig?.permissions;
  if (_permission?.[0] === Permissions.SUB_AGENT) return `Partner `;
  return `Geebee `;
}
